import { post, put, get } from 'utils/fetch';
import { UpdateProjectUrl } from 'models/ProjectData';

export const setupProjectUrl = ({
  projectId,
  updateProjectData
}: {
  projectId: number;
  updateProjectData: UpdateProjectUrl;
}) => put(`/projects/${projectId}`, updateProjectData);

export const validateJsInstalled = (projectId: number) =>
  post(`/projects/${projectId}/validate_site_works_with_bugherd`, {});

type Project = {
  name: string;
  permission: 'guests_see_guests' | 'guests_see_self';
  allow_guests_change_task_status?: boolean;
  assign_guests?: boolean;
  allow_project_summary_email?: boolean;
  allow_task_done_email?: boolean;
  change_guest_default_column?: boolean;
  guest_default_column_name?: string;
};

interface ProjectData {
  organizationId: number;
  project: Project;
}

export const createProject = (projectData: ProjectData) =>
  post(`/organizations/${projectData.organizationId}/projects`, projectData);

export const onboardingCreateExampleTask = (projectId: number) =>
  post(`/projects/${projectId}/create_onboarding_example_task`, {});

export const getProjectTaskCount = (
  projectId: number
): Promise<{ tasks_count?: number }> => get(`/projects/${projectId}.json`);
